import React from 'react';
const KnowledgeSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-knowledge" });
KnowledgeSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-knowledge sirius-icon-knowledge-enhance" });
export default KnowledgeSvg;
